import { render } from "./DockKeyView.vue?vue&type=template&id=2ba6b2fc"
import script from "./DockKeyView.vue?vue&type=script&lang=js"
export * from "./DockKeyView.vue?vue&type=script&lang=js"

import "./DockKeyView.vue?vue&type=style&index=0&id=2ba6b2fc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__